// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  database: {
    apiKey: "AIzaSyBmfb5lbJ29AdVQyp0Jk1Tug6pekx_fTwA",
    authDomain: "pq2-staging.firebaseapp.com",
    databaseURL: "https://pq2-staging.firebaseio.com",
    projectId: "pq2-staging",
    storageBucket: "pq2-staging.appspot.com",
    messagingSenderId: "438992683153",
    appId: "1:438992683153:web:2f37f322f2d9ee4f723f30"
  },
  apiUrl: "https://payments2-ue6wk323oq-ew.a.run.app",
  apiUrl_pos: "https://pos2-ue6wk323oq-ew.a.run.app"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
